import { Reveal } from "./Reveal";
import { SERVICES, IMAGES } from "../../data";
import { Zap, Utensils, Dumbbell, Wine } from "lucide-react";

const ICONS = [Zap, Utensils, Dumbbell, Wine];

export const Services = () => (
  <section
    id="services"
    data-testid="services-section"
    className="relative bg-[#0a0a0a] py-24 md:py-40"
  >
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.3em] text-[#e5ff00]">
            Coaching
          </span>
          <h2 className="mt-5 font-display uppercase text-4xl md:text-6xl leading-[0.9]">
            What you get
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="text-white/60 max-w-sm leading-relaxed">
            One coach, one system, fully tailored to non-traditional hours.
            Remote or hybrid — anywhere in Vegas.
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[i];
          const featured = i === 2;
          return (
            <Reveal key={s.title} delay={i * 0.08}>
              <div
                data-testid={`service-card-${i}`}
                className={`group relative h-full overflow-hidden rounded-xl border border-white/10 bg-[#121212] p-7 hover:-translate-y-2 hover:border-[#e5ff00]/40 transition-[transform,border-color] duration-400 ${
                  featured ? "lg:row-span-1" : ""
                }`}
              >
                {featured && (
                  <img
                    src={IMAGES.dumbbell}
                    alt=""
                    className="absolute inset-0 w-full h-full object-cover opacity-20 group-hover:opacity-30 transition-opacity duration-500 grayscale"
                  />
                )}
                <div className="relative z-10 flex flex-col h-full">
                  <div className="flex items-center justify-between">
                    <span className="inline-flex items-center justify-center h-11 w-11 rounded-full border border-white/15 text-[#e5ff00] group-hover:neon-glow transition-shadow duration-300">
                      <Icon size={20} />
                    </span>
                    <span className="text-[10px] uppercase tracking-[0.25em] text-white/40">
                      {s.tag}
                    </span>
                  </div>
                  <h3 className="mt-8 font-display uppercase text-2xl text-white leading-tight">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm text-white/60 leading-relaxed">
                    {s.desc}
                  </p>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
